export default __webpack_public_path__ + "static/media/coachBanner.9da05f72.png";